module.exports = __webpack_public_path__ + "static/media/logo.5ba631a7.svg";